const INFO = {
	main: {
		title: "Sahil Mund Portfolio",
		name: "Sahil Mund",
		email: "smund2302@gmail.com",
		phone: "+91 6370008924",
		logo: "/logo.jpeg",
	},

	socials: {
		twitter: "https://twitter.com/@sahilmund440504",
		github: "https://github.com/sahil-009",
		linkedin: "https://www.linkedin.com/in/sahil-mund",
		instagram: "https://www.instagram.com/_sahilmund?igsh=MXV4NXMyMTVrdWx2Yw==/",
		stackoverflow: "https://stackoverflow.com/",
		facebook: "https://www.facebook.com/share/17VYErpkMi/",
	},

	homepage: {
		title: "Sahil Mund | Backend Developer",
		description:
			"I am a backend developer with expertise in Node.js. I have experience in building scalable, secure and reliable web applications using various frameworks and technologies.",
	},

	about: {
		title: "I’m Sahil Mund. I live in Bangalore, India.",
		description:
			"I've worked on a variety of projects over the years, many of which are open-source. I'm always open to new ideas and feedback.",
	},

	Hobbies: {
		title: "Beyond Coding",
		description:
			"When I'm not coding, I'm passionate about hitting the gym 💪🏼 and riding my motorcycle 🏍️.",
	},

	articles: {
		title: "My Educational Journey",
		description:
			"My academic background in computer applications and cloud computing.",
	},

	skills: {
		title: "Technical Skills",
		categories: [
			{
				name: "Languages & Scripting",
				items: ["JavaScript (ES6+)", "TypeScript", "PHP", "SQL", "Bash"]
			},
			{
				name: "Frontend",
				items: ["React.js", "Next.js", "Astro", "Tailwind CSS", "SCSS", "Bootstrap", "TurboRepo"]
			},
			{
				name: "Backend",
				items: ["Node.js", "Laravel (MVC)", "Supabase", "RESTful APIs", "SSR with Next.js"]
			},
			{
				name: "Databases & Caching",
				items: ["MySQL", "PostgreSQL", "MongoDB", "Redis"]
			},
			{
				name: "DevOps & Infrastructure",
				items: ["Docker", "PM2", "Nginx", "Apache", "Linux Server (Ubuntu)", "Shell Scripting"]
			},
			{
				name: "Cloud Platforms",
				items: ["AWS (EC2, S3, RDS, EBS, ELB, CloudWatch, Amplify)", "Vercel", "CDN + Object Store"]
			},
			{
				name: "CI/CD & GitOps",
				items: ["Git", "GitHub Actions", "GitLab CI", "Helm"]
			},
			{
				name: "Monitoring & Observability",
				items: ["Grafana", "Prometheus", "CloudWatch"]
			}
		]
	},

	projects: [
		{
			title: "AI-Based Email Client Automation",
			description:
				"Built a real-time multi-IMAP sync system with persistent IDLE connections "
				+ "Implemented Elasticsearch-powered search for lightning-fast query response times."
				+ "Developed AI-based email categorization and RAG-driven reply suggestion engine using a vector database."
				+ "Integrated Slack and Webhooks for real-time notifications and automation workflows.",
			logo: "https://cdn.jsdelivr.net/npm/programming-languages-logos/src/javascript/javascript.png",
			linkText: "View Project",
			link: "https://github.com/sahil-009/email-client-managent.git",
		},

		{
			title: "waste management app react-native",
			description:
				"A waste management app that helps users to manage their waste. it s aapp where include resident and worker like saas where user can add their waste and worker can collect it.",
			logo: "/react-native-logo.png",
			linkText: "View Project",
			link: "https://github.com/sahil-009/waste-management.git",
		},

		{
			title: "CodeManager",
			description:
				"CodeManager is a web application that allows users to manage their code ,usage local storage to store commands.",
			logo: "https://cdn.jsdelivr.net/npm/programming-languages-logos/src/html/html.png",
			linkText: "View Project",
			link: "https://codemanager.vercel.app/",
		},

		{
			title: "Online Code Editor",
			description:
				"Online Code Editor is a web application that allows users to write and run code in real-time. multiple language support.",
			logo: "https://cdn.jsdelivr.net/npm/programming-languages-logos/src/javascript/javascript.png",
			linkText: "View Project",
			link: "https://code-editor30.vercel.app/",
		},

		{
			title: "Readme Generator",
			description:
				"Readme Generator is a web application that generates a README file for a project. It uses a combination of user data to generate a README file.",
			logo: "https://cdn.jsdelivr.net/npm/programming-languages-logos/src/javascript/javascript.png",
			linkText: "View Project",
			link: "https://readme-generator-inky.vercel.app/",
		},
		{
			title: "AI Fitness Trainer",
			description:
				"AI Fitness Trainer is a web application that uses AI to provide personalized fitness recommendations to users. It uses a combination of user data to provide personalized recommendations.",
			logo: "https://cdn.jsdelivr.net/npm/programming-languages-logos/src/javascript/javascript.png",
			linkText: "View Project",
			link: "https://github.com/sahil-009/aiFitnessTrainer.git",
		},
		{
			title: "Chess API",
			description:
				"create a chess api using node.js and express.js.",
			logo: "https://cdn.jsdelivr.net/npm/programming-languages-logos/src/javascript/javascript.png",
			linkText: "View Project",
			link: "https://github.com/sahil-009/chess-api.git",
		}
	],
};

export default INFO;
